import {Container, Col, Row }from 'react-bootstrap';

import Header from '../sections/header';
import Footer from '../sections/footer';
import MainContent from '../sections/maincontent';
import TermsOfServiceText from '../content/TermsOfServiceText';

function PageTerms(){
    return (
        <> 
            <Header />
            <Container fluid className="color-bg-secondary">
                    <MainContent>
                        <Row>
                            <Col md={{span: 8, offset: 2}}>
                                <TermsOfServiceText />
                            </Col>
                        </Row>     
                    </MainContent>
            </Container>
            <Footer />
        </>
    )
}

export default PageTerms;